import React from 'react';
import { Input } from 'antd';
import { Field, FieldProps } from 'formik';
import { InputProps } from 'antd/lib/input';
import { FormikFieldProps } from 'formik-antd/lib/FieldProps';
import MaskedInput, { MaskedInputProps } from 'react-text-mask';

import SecureInput from 'components/formik/SecureInput';

type OwnProps = {
  onChange?: (value: string) => void;
  secureMode?: boolean;
};

type Props = MaskedInputProps & InputProps & FormikFieldProps & OwnProps;

export default function InputMask({
  showMask = true,
  guide = false,
  name,
  validate,
  fast,
  onChange: $onChange,
  onBlur: $onBlur,
  secureMode = false,
  ...restProps
}: Props) {
  const InputComponent = secureMode ? SecureInput : Input;

  return (
    <Field name={name} validate={validate} fast={fast}>
      {({
        field: { value, name, onBlur },
        form: { setFieldValue },
      }: FieldProps) => (
        <MaskedInput
          showMask={showMask}
          guide={guide}
          {...restProps}
          render={(ref, props) => (
            <InputComponent
              name={name}
              value={value}
              ref={(input: any) => ref(input && (input.input as any))}
              {...props}
              {...restProps}
              onChange={(event) => {
                props.onChange(event);
                setFieldValue(name, event.target.value);
                $onChange && $onChange(event.target.value);
              }}
              onBlur={(event) => {
                onBlur(event);
                $onBlur && $onBlur(event);
              }}
              autoComplete="off"
            />
          )}
        />
      )}
    </Field>
  );
}
